import {
  TComponentValue,
} from '@/types/openapi-type.ts';

const details: Record<TComponentValue<'QmulusLicenseViolationReason'>, string> = {
  NO_LICENSE_KEY: 'Aby Kontynuuj korzystanie z Qmulus, należy podać ważny klucz licencyjny.',
  ASSET_LIMIT_VIOLATED: 'Skonfigurowano zbyt wiele zasobów.',
  EXPIRED: 'Klucz licencyjny wygasł ponad {expiryGracePeriodDays} dni temu',
  EXPIRED_GRACE_PERIOD: 'Licencja wygasła. Zaktualizuj ją jak najszybciej, w przeciwnym razie utracisz dostęp do Qmulus.',
  INVALID: 'Wprowadzony klucz licencyjny jest nieprawidłowy.',
  USER_LIMIT_VIOLATED: 'Skonfigurowano zbyt wielu użytkowników.',
  OTHER: 'Nieznany błąd podczas weryfikacji licencji.',
};

export default {
  enterLicense: 'Wprowadź klucz licencyjny',
  contactSales: 'Aby uzyskać nową licencję, skontaktuj się z przedstawicielem handlowym Qmulus',
  ignore: 'Ignoruj',
  expiresSoon: {
    summary: 'Klucz licencyjny wkrótce wygaśnie',
    details: 'Klucz licencyjny wygaśnie {date}',
  },
  details,
};
